import { Map, Set } from 'immutable';

export const keyIn = (...keys) => (v, k) => Set(keys).has(k);

// use with mapEntries to convert all keys in an object, including the nested ones, to camelCase.
export const toCamelCase = ([key, value]) => [
    key.replace(/[-_]+(\w?)/g, (match, letter) => (letter ? letter.toUpperCase() : '')),
    Map.isMap(value) ? value.mapEntries(toCamelCase) : value
];



// WEBPACK FOOTER //
// ./source/utils/immutable.js